export const PlaygroundDateMessage = ({ date }: { date: string }) => {
  return (
    <li className={'text-xs text-ebony_opacity_30 flex justify-center'}>
      <span>{date}</span>
    </li>
  );
};
